<template>
  <div>
    <fg-input v-model="item.id" :label="$t('replacementRules.id')" readonly="true"/>
    <fg-input v-model="item.type" :label="$t('replacementRules.configuration')"/>
    <FormButtons
            @submit="submit"
            :submit="$UIPrivilegeU('realtime/replacementRuleConfigs')"   
            :reset="false"
            @remove="remove"
            :remove="action == 'item'" 
            :itemid="this.item.id"
            :modalid="'replacementRuleConfigEditModal'"
            :disableSubmit="loading"
            :disableRemove="loading "/>
        
    <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
  </div>
</template>

<script>
import replacementRules from '@/store/realtime/replacementRules'

export default {
    name: 'ReplacementRuleConfigForm',
    props: {
        ruleConfig: { default: null },
        action: { default: 'new' }
    },
    data: function() {
        return {
            item: {
                'type' : this.ruleConfig.type,
                'id' : this.ruleConfig.id+""
            },
            ok: false,
            error: false,
            loading: false,
            infoType: 'save'
        }
    },
    watch: {
        ruleConfig(newItem) {
            const rule = { ...newItem }
            rule.id = ""+rule.id
            this.item = rule
        }
    },
    methods: {
        submit() {
            this.ok = this.error = false
            this.infoType = "save"
            this.loading = true
            const saveItem = { ...this.item }
            let submitUrl = 'replacementRules/updateReplacementRuleConfig'
            if( this.action == 'new' ) {
                delete saveItem.id
                submitUrl = 'replacementRules/addReplacementRuleConfig'
            }
            this.$store.dispatch( submitUrl , saveItem ).then(() => {
                this.ok=true
                this.error =false
            }).catch(() => {
                this.error = true
            }).finally(() => {
                this.loading = false
            })
        },
        remove() {
            if( this.item.id == undefined )
                return
            this.loading = true
            this.ok = this.error = false
            this.$store.dispatch('replacementRules/removeReplacementRuleConfig' , this.item.id ).then(() => {
                this.$emit('itemRemoved')
            }).catch(() => {
                this.error = true
            }).finally( () => {
                this.loading =false
            })
        }
    },
    beforeCreate() {
        if( !this.$store.state.replacementRules ) {
            this.$store.registerModule("replacementRules" , replacementRules )
        }
    },

}
</script>

<style>

</style>